import LocalizationService from '@/services/localization-service'

const LocalizationMixin = {
  methods: {
    getTranslatedField(localizationObject, field, fallback = false, locale = null) {
      return LocalizationService.getTranslate(localizationObject, field, locale ?? this.$i18n.locale, !fallback)
    },
    setTranslatedField(localizationObject, field, value, locale = null, defaultLocaleObject = { name: '' }) {
      const currentLocale = locale ?? this.$i18n.locale
      const locales = localizationObject?.locale ?? localizationObject?.locales ?? localizationObject
      let localeIdx = LocalizationService.getLocaleIndex(localizationObject, currentLocale)

      if (localeIdx < 0) {
        locales.push({ locale: currentLocale, ...defaultLocaleObject })
        localeIdx = locales.length - 1
      }

      locales[localeIdx][field] = value
      this.$forceUpdate()
    },
  },
}

export default LocalizationMixin
